export default __webpack_public_path__ + "static/img_3-c39de276c8ae890ff2152a18ede3b1d4.webp";